export default __webpack_public_path__ + "static/media/appstrore-light.f170367d.webp";